import { api } from 'app/config/apiConfig';
import { VerificationDocument } from '../model/types';

export const getContractVerificationDocumentsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getContractVerificationDocuments: builder.query<VerificationDocument[], { contractId: string }>({
      query: ({ contractId }) => ({
        url: `/contracts/${contractId}/verification-documents`,
        params: { latestOnly: true },
      }),
      providesTags: ['VerificationDocuments'],
    }),
  }),
});

export const { useGetContractVerificationDocumentsQuery } = getContractVerificationDocumentsApi;
